// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__UbBCB","active":"MainHeader_active__0mkTJ","dropdown":"MainHeader_dropdown__FzEwd"};